// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OldNewWordsFrame{background:#ff5200}.OldNewWordsFrame .OldNewWordsFrame__svg-parent{margin-left:auto;margin-right:auto;width:100%;max-width:1440px}.ra-mobile .OldNewWordsFrame .OldNewWordsFrame__svg-parent{margin:0;width:auto}.OldNewWordsFrame .OldNewWordsFrame__copyright{font-size:9px;font-weight:400;font-style:normal;line-height:11px;letter-spacing:.04em;text-transform:uppercase;color:#888}", ""]);
// Exports
module.exports = exports;
